module.exports = __webpack_public_path__ + "img/ae52b9e.jpg";